import React from 'react';
import styles from './OverviewSections.module.css';

/**
 * The five fact tiles at the top of the overview: Focus, Participation,
 * Eligibility, Application stages, Current stage.
 *
 * Focus, Participation, Application stages and Current stage are left out when
 * the overview has no data for them. Eligibility is always shown, with a
 * "to be added" line when empty, because a student should know it is missing
 * rather than not see it at all.
 */
const FactTiles = ({ overview, currentStage }) => {
  const stageCount = (overview.stages || []).length;

  const tiles = [];
  if (overview.focus) tiles.push({ label: 'Focus', value: overview.focus });
  if (overview.participation) tiles.push({ label: 'Participation', value: overview.participation });
  tiles.push({ label: 'Eligibility', value: overview.eligibility || null });
  if (stageCount) {
    tiles.push({ label: 'Application stages', value: `${stageCount} stage${stageCount === 1 ? '' : 's'}` });
  }
  if (currentStage) tiles.push({ label: 'Current stage', value: currentStage.name });

  return (
    <div className={styles.tiles}>
      {tiles.map((t) => (
        <div key={t.label} className={styles.tile}>
          <span className={styles.eyebrow}>{t.label}</span>
          <div className={styles.tileValue}>
            {t.value || (
              <span className={styles.toBeAdded}>To be added from the CreatED competition guide</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FactTiles;
